module.exports = __webpack_public_path__ + "static/Manrope-SemiBold-255d425d09667bc095e79a8bd8081aba.ttf";